import { Action } from '@reduxjs/toolkit';

import { logout } from 'app/redux/actions/auth';

import {
  REMOVE_CASHED_OUT_STAKE, RemoveCashedOutStake,
  SAVE_CASHING_OUT_STAKE, SaveCashingOutStake,
} from '../actions/cashout';
import type { CashOutStakesState } from '../types/cashOutStakes';

// ---

type Logout = Action<typeof initialState>;
type ActiveStakesActions =
  | SaveCashingOutStake
  | RemoveCashedOutStake
  | Logout;

const initialState: CashOutStakesState = new Map();

export default function (state = initialState, action: ActiveStakesActions): CashOutStakesState {
  switch (action.type) {
    case SAVE_CASHING_OUT_STAKE:
      return new Map(state).set(action.payload.stakeId, action.payload.dialogId);

    case REMOVE_CASHED_OUT_STAKE: {
      const newState = new Map(state);
      newState.delete(action.payload.stakeId);

      return newState;
    }

    case logout.pending.toString():
      return initialState;

    default:
      return state;
  }
}
